import { httpClient, HttpMethod } from './http-client';
import { ServiceStatusResponse, AvailableStatusesForServiceTypes } from '../@types/service.type';

export const createServiceStatus = (nodeType: ServiceStatusResponse): Promise<ServiceStatusResponse> => {
  return httpClient<ServiceStatusResponse>('/serviceStatuses', HttpMethod.Post, nodeType);
};

export const updateServiceStatus = (code: string, nodeType: ServiceStatusResponse): Promise<ServiceStatusResponse> => {
  return httpClient<ServiceStatusResponse>(`/serviceStatuses/${code}`, HttpMethod.Put, nodeType);
};

export const getServiceStatusByCode = (code: string): Promise<ServiceStatusResponse> => {
  return httpClient<ServiceStatusResponse>(`/serviceStatuses/${code}`, HttpMethod.Get);
};

export const getAllServiceStatus = (): Promise<ServiceStatusResponse[]> => {
  return httpClient<ServiceStatusResponse[]>('/serviceStatuses', HttpMethod.Get);
};

export const getPossibleStatusesByServiceTypes = (code: string, serviceTypes: string[]): Promise<AvailableStatusesForServiceTypes> => {
  return httpClient<AvailableStatusesForServiceTypes>(`/serviceStatuses/${code}/getByServiceTypes?serviceTypes=${encodeURIComponent(JSON.stringify(serviceTypes))}`, HttpMethod.Get);
};
